import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { Token } from './service/token';

export const apiAuthorizationInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const token = inject(Token).auth();
  if (token) {
    req = req.clone({
      headers: req.headers.set('Authorization', token),
    });
  }
  return next(req);
};

export const lcmInterceptors = () => [apiAuthorizationInterceptor];
